const ARTICLES = 'ARTICLES';
const ONBOARDINGS = 'ONBOARDINGS';
const KNOWLEDGE_LIBRARIES = 'KNOWLEDGE_LIBRARIES';

export const defaultTranslations = {
  en: {
    ARTICLES: 'Magazine',
    FEED: 'Feed',
    KNOWLEDGE_LIBRARIES: 'Libraries',
    ONBOARDINGS: 'Onboarding',
  },
  es: {
    ARTICLES: 'Noticias',
    FEED: 'Muro',
    KNOWLEDGE_LIBRARIES: 'Librerías',
    ONBOARDINGS: 'Onboarding',
  },
  pt: {
    ARTICLES: 'Notícias',
    FEED: 'Mural',
    KNOWLEDGE_LIBRARIES: 'Bibliotecas',
    ONBOARDINGS: 'Onboarding',
  },
};

export const defaultTranslationsWithNoInformation = {
  en: {
    NO_ARTICLES: 'No articles',
    NO_ONBOARDINGS: 'No onboarding yet',
    NO_KNOWLEDGE_LIBRARIES: 'No knowledge libraries available',
  },
  es: {
    NO_ARTICLES: 'No hay artículos',
    NO_ONBOARDINGS: 'Todavía no hay onboarding',
    NO_KNOWLEDGE_LIBRARIES: 'No hay librerías de conocimiento disponibles',
  },
  pt: {
    NO_ARTICLES: 'Não há artigos',
    NO_ONBOARDINGS: 'Ainda não há onboarding',
    NO_KNOWLEDGE_LIBRARIES: 'Nenhuma biblioteca disponível',
  },
};

export const translationsWithNoInformation = (nameSpace, nameNewModule) => {
  if (nameSpace === ARTICLES) {
    return {
      en: {
        NO_ARTICLES: `There aren't any ${nameNewModule} to show yet.`,
      },
      es: {
        NO_ARTICLES: `Por ahora no hay ${nameNewModule} para mostrar.`,
      },
      pt: {
        NO_ARTICLES: `Ainda não há ${nameNewModule} para mostrar.`,
      },
    };
  }
  if (nameSpace === ONBOARDINGS) {
    return {
      en: {
        NO_ONBOARDINGS: `No ${nameNewModule} yet`,
      },
      es: {
        NO_ONBOARDINGS: `Todavía no hay ${nameNewModule}`,
      },
      pt: {
        NO_ONBOARDINGS: `Ainda não há ${nameNewModule}`,
      },
    };
  }
  if (nameSpace === KNOWLEDGE_LIBRARIES) {
    return {
      en: {
        NO_KNOWLEDGE_LIBRARIES: `No ${nameNewModule} available`,
      },
      es: {
        NO_KNOWLEDGE_LIBRARIES: `No hay ${nameNewModule} disponibles`,
      },
      pt: {
        NO_KNOWLEDGE_LIBRARIES: `Nenhuma ${nameNewModule} disponível`,
      },
    };
  }
  return null;
};

export const nameSpacesWithCustomTitles = ['ARTICLES', 'FEED', 'KNOWLEDGE_LIBRARIES', 'ONBOARDINGS'];
export const nameSpacesWithNoInformationTitles = ['ARTICLES', 'KNOWLEDGERKNOWLEDGE_LIBRARIES', 'ONBOARDINGS'];
